<template>
  <div class="row">
    <div class="col-sm-12">
      <div>
        <label id="select_design">
          {{ $t('selectADesign') }}<span class="text-danger pl-1">*</span>
        </label>
      </div>
      <div role="radiogroup" aria-labelledby="select_design">
        <button
          v-for="design in designs"
          :key="design.id"
          @click="change(design)"
          class="unstyled-btn"
          type="button"
          role="radio"
          :aria-checked="value === design"
        >
          <WCImage
            :imageSrc="`${$configuration.cdn}/api/img/${design.image}`"
            :imageAlt="$t('giftCardWithIdImgAltText', { id: design.description })"
            :imageClass="`gift-card-design-selector__img ${value === design && 'active'}`"
            :defaultClass="
              `gift-card-design-selector__img ${value === design &&
                'active'} v-align-none font-size-7xl`
            "
          />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import WCImage from '@/components/WCImage/WCImage.vue';

export default {
  components: { WCImage },
  props: {
    designs: {
      type: Array,
    },
    value: {
      type: Object,
    },
  },
  created() {
    if (!this.value) {
      this.$emit('input', this.designs[0]);
    }
  },
  methods: {
    change(design) {
      this.$emit('input', design);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.gift-card-design-selector__img {
  cursor: pointer;
  width: rem(150px);
  height: rem(100px);
  margin: 0 $margin-3 $margin-3 0;
  border: 3px transparent solid;
  border-radius: 10px;
  &:hover,
  &:focus,
  &.active {
    border: 1px solid #006ba6;
  }
  .active {
    border-color: #ffffff;
  }
}

.v-align-none {
  vertical-align: -0.625em;
}
</style>
